import React, { useContext } from 'react';
import { Title } from 'components';
import { hasValidStripeMlsProductId } from 'utils';
import { AuthContext } from 'contexts';

import { StyledPageContent } from '../StyledComponents';

import EnhancedMyPlan from './EnhancedMyPlan';
import LegacyMyPlan from './LegacyMyPlan';

const MyPlan: React.FC = () => {
  const { answeringPortalConfig } = useContext(AuthContext);

  return (
    <StyledPageContent>
      <Title level={2} data-cy="choose-plan-title">
        Choose your plan
      </Title>
      {hasValidStripeMlsProductId(answeringPortalConfig?.mlsProductId) ? (
        <EnhancedMyPlan />
      ) : (
        <LegacyMyPlan />
      )}
    </StyledPageContent>
  );
};

export default MyPlan;
